import { AxiosResponse } from 'axios'
import { IStateUser } from '../types'
import { serverApi } from '../utils/request'
import Path from '../utils/paths'

class UserService {
  public async fetchUserById(id: string): Promise<any> {
    return serverApi
      .get<any>(Path.user.baseWithId.replace(':id', id))
      .then((result: AxiosResponse<IStateUser>) => result.data)
  }
}

const userService = new UserService()

export { userService }



// WEBPACK FOOTER //
// ./src/services/User.ts